async function simulateMouseClick(el: HTMLButtonElement) {
  try {
    const opts = { view: window, bubbles: true, cancelable: true, buttons: 1 };
    el.dispatchEvent(new MouseEvent('mousedown', opts));
    await new Promise((r) => {
      setTimeout(r, 50);
    });
    el.dispatchEvent(new MouseEvent('mouseup', opts));
    el.dispatchEvent(new MouseEvent('click', opts));
  } catch (e) {
    console.log(e);
  }
}

export default simulateMouseClick;
